<template>
    <div class="form-field" :class="{'form-field--error': hasError || parentError}">
        <label :for="name" class="form-field__label">{{label}}<span class="form-field__optional" v-if="isOptional"> {{optional}}</span></label>
        <textarea :name="name" 
                    :placeholder="placeholder"
                    :required="!isOptional"
                    v-model="inputValue"
                    @focus="focus()"
                    @blur="unfocus()"
                    @input="validateValue($event.target.value)"
                    v-validate="rules"
                    :disabled="disabled"
                    class="form-field__input-container form-field__input form-field__input--textarea"> 
        </textarea>
    </div> 
</template>
<script>
    import {mapGetters} from 'vuex';

    export default {
        props: {
            label: String,
            name: String,
            type: String,
            validation: String,
            value: null,
            placeholder: String,
            disabled: Boolean,
            optional: {
                type: String,
                default: ''

            },
            withRow: {
                type: Boolean,
                default: false
            },
            parentError: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                focused: false,
                needsValidate: false,
                hasError: false,
                inputValue: ''
            }
        },
        computed: {
            ...mapGetters('form', [
                'entries'
            ]),
            isOptional: function() {
                return this.optional !== '';
            },
            rules: function() {
                return this.validation === '' ? false : this.validation;
            }
        },
        watch: {
            hasError: function() {
                this.needsValidate = true;
            },
            value: function(value) {
                this.inputValue = value;
            }
        },
        methods: {
            validate: function() {
                return this.$validator.validate().then((result) => {
                    this.hasError = !result;

                    return result;
                });
            },
            focus: function() {
                this.focused = true;
                this.$emit('focus');
            },
            unfocus: function() {
                this.validate();
                this.$emit('blur');
            },
            validateValue: function(value) {
                if (this.needsValidate) {
                    this.validate();
                }

                this.$emit('input', value);
            }
        },
        mounted: function() {
            this.inputValue = this.value;
        }
    }
</script>